export default __webpack_public_path__ + "static/media/black_right_arrow.a801582c.svg";